import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AdsignMapProvider } from "./adsignMapProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AdsignMapProvider>
      <App />
    </AdsignMapProvider>
  </React.StrictMode>
);
